export default {
  FR_CA: "fr-ca",
  HI_IN: "hi-in",
}